/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$(document).ready(function() {

  $('.featured-product-list_grid.slider').each(function() {
    
    // var desktopSlidesToShow = parseInt($(this).attr('desktop_per_row'));
    // var mobileSlidesToShow = parseInt($(this).attr('mobile_per_row'));
    
    $(this).slick({
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 2,
            arrows: false
          }
        },
        {
          breakpoint: 740,
          settings: "unslick"
        }
      ]
    });
  });

  $(".testimonial-sec-list").slick({
      arrows:true,
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
      {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            infinite: true,
            arrows: false,
            dots: false
          }
        }
    ]
  });

  // $(".pdp-tab-slct-optn-pro-blck").slick({
  //   arrows:true,
  //   dots: false,
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 740,
  //       settings: "unslick"
  //     }
  //   ]
  // });

  $('body').on('click','.content-wrapper .read-toggle', function(){
    if($(this).hasClass('readmore')){
      $(this).closest('.content-wrapper').find('.custom_content_wrapper').addClass('active');
      $(this).text('Read less').removeClass('readmore');
    }else{
      $(this).closest('.content-wrapper').find('.custom_content_wrapper').removeClass('active');
      $(this).text('Read more').addClass('readmore');
    }
    
  });

  $('.shop-the-look-sec-content-list').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   dots: false
 });
 $('.shop-the-look-sec__dot').click(function(e) {
   e.preventDefault();
   $(this).closest('.shop-the-look__item').find('.shop-the-look-sec__dot').removeClass('active');
   $(this).addClass('active');
   var slideno = $(this).data('slide');
   $('.shop-the-look-sec-content-list').slick('slickGoTo', slideno - 1);
 });
  $('.shop-the-look-sec-content-list').on('afterChange', function(event, slick, currentSlide){
  $('.shop-the-look-sec__dot').removeClass('active');
  $('.shop-the-look-sec__dot[data-slide="' + (currentSlide + 1) + '"]').addClass('active');
  });

  $("body").on("click",".iw-accor-item-title", function(){
    var activeTitle = $(this);
    activeTitle.toggleClass("active");
    var currentDropdownn = activeTitle.next(".iw-accor-item-text");
    $(".iw-accor-item-title").not(activeTitle).removeClass("active");
    $(".iw-accor-item-text").not(currentDropdownn).slideUp();
    currentDropdownn.stop(true, true).slideToggle();
  });

  $('.product-offer-heading').click(function(){
   $(this).toggleClass('active');
   $(this).next().slideToggle();
  });

  // FOR BUY IT WITH WIDTH:
  const productformElement = document.getElementsByClassName('product-form')[0];
  if (productformElement) {
    const productformWidth = productformElement.clientWidth;
    document.documentElement.style.setProperty('--productform-width', productformWidth + 'px');
  } else {
  }

  $("body").on("click",".product-form__option-link", function(){
    $(this).closest(".product__info").find(".size_guide_modal").attr("open", true);
    $(this).closest(".drawer--quick-buy").find(".size_guide_modal").attr("open", true);
  });
  $("body").on("click",".size_guide_modal .modal__overlay, .size_guide_modal .modal__close-button", function(){
    $(this).closest(".size_guide_modal").attr("open", false);
    $(this).closest(".drawer__content").find(".size_guide_modal").attr("open", false);
  })
  $("body").on("click",".product-ft-fit", function(){
    $(this).closest(".product__info").find(".custom_fit_type_modal").attr("open", true);
  });
  $("body").on("click",".custom_fit_type_modal .modal__overlay, .custom_fit_type_modal .modal__close-button", function(){
    $(this).closest(".custom_fit_type_modal").attr("open", false);
  });

  $('body').on('click','.top-bar-size-filter-list .checkbox-container input[type="checkbox"]',function(e){
    e.preventDefault();
    console.log('innn');
    var _this = $(this);
    var href = $(this).attr('name');
    var val = $(this).attr('value');
    if(val != undefined && val != ''){
      console.log('1111');
      var currentURL = window.location.href;
      var finalVAL = href+'='+val;
      var is_current = false;
      var without_cur = [];
      var params = {};
      var parser = document.createElement('a');
      parser.href = window.location.href;
      var query = parser.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');        
        if(encodeURI(href) == pair[0] && val == pair[1]){
          is_current = true;
        }else{
          if(_this.closest('.top-bar-size-filter-list').hasClass('single_value')){
            if(encodeURI(href) == pair[0]){
             without_cur.push(pair[0] + '=' + val);    
            }else{
             without_cur.push(pair[0] + '=' + pair[1]);    
            }
          }else{
           without_cur.push(pair[0] + '=' + pair[1]); 
          }          
        }
      }
      if(is_current){  
        console.log('3333');
        currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
        if(without_cur.length > 0){
          currentURL = currentURL + '?' +without_cur.join('&')
        }else{              
          currentURL = currentURL;
        }            
      }else{
        console.log('2222');
        if(_this.closest('.top-bar-size-filter-list').hasClass('single_value') && currentURL.indexOf(href) > -1){
          var newurl = [];
          currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');        
            if(encodeURI(href) == pair[0]){
              newurl.push(finalVAL);
            }else{                
              newurl.push(pair[0] + '=' + pair[1]);                 
            }
          }
          if(currentURL.indexOf('?') >= 0){
            currentURL = currentURL + '&' + newurl.join('&');
          }else{
            currentURL = currentURL + '?' + newurl.join('&');
          }
        }else{
         if(currentURL.indexOf('?') >= 0){
            currentURL = currentURL + '&' + finalVAL;
          }else{
            currentURL = currentURL + '?' + finalVAL;
          }  
        }        
      } 
      console.log(currentURL);
      this.dispatchEvent(new CustomEvent("facet:criteria-changed", {
        bubbles: true,
        detail: {
          url: currentURL.toString()
        }
      }));
    }
  });

  $("body").on("click", ".product-offer-copy-code", function () {
    var copy_text = $(this).find(".product-offer-copied");
    var text = $(this)
      .closest(".pro-offer-blck-content")
      .find(".pobc-code-text")
      .text();
    var $temp = $("<input>");

    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html("Copied");
    setTimeout(function () {
      copy_text.html("");
    }, 1000);
  });

  $('body').on('change','.has_size [data-selector-type="block"] .block-swatch__radio', function(){
    var closest = $(this).closest('.has_size');
    if(closest.find('[data-selector-type="block"] .block-swatch__radio:checked').closest('.block-swatch').hasClass('is-disabled') == false){
      closest.find('[data-product-add-to-cart-button] .loader-button__text').html(document.querySelector("[data-product-add-to-cart-button]").getAttribute("data-button-content")); 
    }      
    closest.find('[data-product-add-to-cart-button]').removeAttr('disabled');
  }); 

  $('#stickaddtocart-scroll').on('click', function () {
    const target = $('.product-form__variants');
    const targetOffset = target.offset().top;
    const windowHeight = $(window).height();
    const scrollPosition = targetOffset - (windowHeight / 2) + (target.outerHeight() / 2);

    $('html, body').animate({
      scrollTop: scrollPosition
    }, 800);
  });

  $(".show-more").click(function () {
    if ($(this).closest('.collection_seo_content').find('.collection__description').hasClass("active")) {
      $(this).closest('.collection_seo_content').find('.collection__description').removeClass('active');
      $(this).text("(Show More)");
    } else {
      $(this).closest('.collection_seo_content').find('.collection__description').addClass('active');      
      $(this).text("(Show Less)");
    }
  });
  
})
